export default {
  primary: "#00ADEF",
  success: "#01cc88",
  warning: "#FF9C41",
  danger: "#FA5C5C",
  info: "#00d0ff",
} as const;
